import { Grid2, IconButton, useMediaQuery } from '@mui/material';
import { CircularLoading } from '@myhrbox/myhrbox-frontend-core';
import BurgerIcon from 'assets/icons/Burger';
import CloseIcon from 'assets/icons/Close';
import { useState } from 'react';
import { Me } from 'store/user/types';
import MenuStack from './MenuStack';
import Navigation from './Navigation';
import User from './User';

interface IHeaderProps {
  me: Me;
  meLoading: boolean;
}

const Header = ({ me, meLoading }: IHeaderProps) => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const [menuOpened, setMenuOpened] = useState(false);

  const toggleMenu = () => {
    if (menuOpened) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = 'hidden';
    }

    setMenuOpened(!menuOpened);
  };

  if (meLoading) return <CircularLoading />;

  return (
    <Grid2 size={{ xs: 3, md: 9 }} sx={{ display: { md: 'block', xs: 'contents' } }}>
      <IconButton
        onClick={toggleMenu}
        sx={{
          display: { md: 'none' },
          marginLeft: 'auto',
          padding: 0,
          '&:hover': { backgroundColor: 'transparent' },
        }}>
        {menuOpened ? (
          <CloseIcon sx={{ color: 'primary.main', width: 40, height: 40 }} />
        ) : (
          <BurgerIcon sx={{ color: 'primary.main', width: 40, height: 40 }} />
        )}
      </IconButton>

      <MenuStack
        direction={isMobile ? 'column' : 'row'}
        spacing={2}
        sx={
          !menuOpened && isMobile
            ? {
                maxHeight: '0 !important',
                visibility: 'hidden',
                overflow: 'hidden',
                opacity: 0,
                marginTop: '-32px',
              }
            : null
        }>
        <Navigation isMobile={isMobile} toggleMenu={toggleMenu} />
        <User me={me} isMobile={isMobile} />
      </MenuStack>
    </Grid2>
  );
};

export default Header;
